import './pwaManifestLink.js'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import { changeLocale, createPanelI18n, fetchServerDefaultLocale } from './i18n'
import { migrateLegacyStorageKeys } from '@/utils/storageKeys'
import { STORAGE_KEYS } from '@/utils/storageKeys'

import './assets/css/main.css'
import 'flag-icons/css/flag-icons.min.css'
import './registerServiceWorker'
import { initPwaUpdateHandler } from './setup/pwaUpdateHandler'

const i18n = createPanelI18n()

migrateLegacyStorageKeys()

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
  console.error('❌ Global error:', err, info)
}

app.use(createPinia())
initPwaUpdateHandler()

app.use(router)

app.use(i18n)

app.mount('#app')

fetchServerDefaultLocale().then((serverDefaultLocale) => {
  if (serverDefaultLocale && !localStorage.getItem(STORAGE_KEYS.LOCALE)) {
    changeLocale(serverDefaultLocale, false)
  }
})
